// linted by Ricky Kim

import React from 'react';
import MobileHeader from '../Components/MobileHeader';
import JurorBarcode from '../Components/JurorBarcode';
import Attendance from '../Components/Attendance';
import SocialMedia from '../images/SocialMediaFlyer.jpg';
import Check from '../green check mark.jfif';
import '../App.css';

export default class BarcodeAttendance extends React.Component {
    render() {
        return (
            <div>
                <MobileHeader
                    jurorName={this.props.jurorName}
                    jurorReportingDateTime={this.props.jurorReportingDateTime}
                    logOut={this.props.logOut}
                />
                <main>
                <h1 className="visually-hidden">Jury Questionnaire</h1>
                <div className="Deferment">
                    {!this.props.isSpecial && (
                        <div className="Center">
                            <img className="Check" alt="Check Mark" src={Check} />
                            Thank you for filling out your questionnaire
                        </div>
                    )}
                    <p />
                    <div className="Center">
                        Your check-in QR code:
                        <JurorBarcode className="Center" jurorID={this.props.jurorID} />
                    </div>
                    <div className="Center">
                        <Attendance jurorID={this.props.jurorID} jurorReportingDateTime={this.props.jurorReportingDateTime} />
                    </div>
                    <div className="Center">
                        Please watch the following video
                        <video controls className="Center">
                            <track kind="captions" />
                            <source src="https://www.dropbox.com/s/5bs8sbc1c4x0noy/Jury%20PSA.mp4?dl=0&raw=1" type="video/mp4" />
                        </video>
                    </div>
                </div>
                <div className="Center FAQ">
                    <h3>First Day Instructions:</h3>
                    <ul className="faq-ul">
                        <li>
                            Are you a resident of Clayton County? <span className="bold">NO?</span> Please go to the window.
                        </li>
                        <li>
                            Are you a United States citizen? <span className="bold">NO?</span> Please go to the window.
                        </li>
                        <li>
                            Are you 70 years of age or older and do NOT want to serve? <span className="bold">YES?</span> Please go to the window.
                        </li>
                        <li>
                            Have you been convicted of a felony and your civil rights have NOT been restored? <span className="bold">YES?</span>{' '}
                            Please go to the window.
                        </li>
                    </ul>
                    <div className="dos-and-donts">
                        <div className="jury-dos">
                            <h3>Jury Duty Do&#39;s:</h3>
                            <ul className="faq-ul">
                                <li>DO be on time!</li>
                                <li>DO pay close attention to instructions.</li>
                                <li>DO respect those around you.</li>
                                <li>DO have cell phones/electronic devices turned off while in the courtroom.</li>
                            </ul>
                        </div>
                        <div className="jury-donts">
                            <h3>Jury Duty Dont&#39;s</h3>
                            <ul className="faq-ul">
                                <li>DON&#39;T wear shorts, uniforms or clothing too revealing or inappropriate.</li>
                                <li>DON&#39;T be late! (You may be held in CONTEMPT!)</li>
                                <li>DON&#39;T go to the window and ask when you&#39;ll be leaving.</li>
                                <li>
                                    DON&#39;T try to get out of jury duty. The law allows very few excuses and we are obligated to uphold the law.
                                </li>
                            </ul>
                        </div>
                    </div>
                    <h3>Jury Duty Pay:</h3>
                    <p className="faq-text">
                        You will be paid $25.00 for each day that you are required to appear whether you are selected as a juror or not. The
                        certificate will list the dates you have been required to appear for jury duty. You will be handed your check and certificate
                        of service when you are released from jury duty IF you have abided by all instructions given and have not failed to appear
                        when required during your term of jury duty. *NOTE* Any attempt to alter either the check or the certificate of service in ANY
                        way may constitute a criminal act which will be prosecuted.
                    </p>
                    <h3>Attendance:</h3>
                    <p className="faq-text">
                        It is extremely important that you report as instructed! If a juror fails to report or absents themself without prior approval
                        from the court, that juror will not be paid, may be required to re-serve their jury duty, or may be held in contempt of court.
                    </p>
                    <h3>Emergencies:</h3>
                    <p className="faq-text">
                        If you are unable to report because of an emergency, please call 770-477-3400 as soon as possible. If there is inclement
                        weather, please tune in to WSB-TV News or WSB750 AM or WSB95.5FM for any announcement regarding the closing/delayed opening of
                        Clayton County Government.
                    </p>
                    <div className="important">
                        <p>
                            <span className="bold">IMPORTANT!</span> Jurors may not have anyone scan in their code for attendance. Any person who
                            participates in the fraudulent usage of the scanning statement may be held in contempt of court.
                        </p>
                    </div>
                </div>
                <img className="flyer" src={SocialMedia} alt="a flyer outlining rules for social media usage in the courtroom" />
                </main>
            </div>
        );
    }
}
